import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src2161573508/src/nuxt/layouts/default.vue").then(m => m.default || m))
}